module.exports = __webpack_public_path__ + "img/my_invitations.45ef94c0.png";